import { ROUTE_PATHS } from "@routes/routePath";

export const moveToFillInTable = (id: string) => {
  const url = `${ROUTE_PATHS.fillInTable}?id=${id}`;
  window.open(url, "_blank");
};
